import './Admin.css';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import AdminHeader from '../AdminHeader/AdminHeader';
import AdminSidebar from '../AdminSidebar/AdminSidebar';
import { Switch, Route } from "react-router-dom";
import Requests from '../Requests/Requests.jsx';
import Warehouse from '../WarehousePage/WarehousePage';
import ReferralPartners from '../ReferralPartner/ReferralPartner';
import Settings from '../Settings/Settings';
import Statistics from '../Statistics/Statistics';

function Admin() {
    return (
        <>
        <AdminHeader />
        <Container fluid>
            <Row>
                <AdminSidebar />
                <Col md={10} lg={10} className="ml-sm-auto">
                    <main className="d-flex flex-wrap flex-md-nowrap pt-4">
                    <Switch>
                            <Route path="/admin/requests">
                                <Requests />
                            </Route>
                            <Route path="/admin/warehouse">
                                <Warehouse />
                            </Route>
                            <Route path="/admin/referral-partners">
                                <ReferralPartners />
                            </Route>
                            <Route path="/admin/settings">
                                <Settings />
                            </Route>
                            <Route path="/admin/statistics">
                                <Statistics />
                            </Route>
                            </Switch>
                    </main>
                </Col>
            </Row>
        </Container>
        </>
    );
}

export default Admin;